import CartItemLayout from './CartItemLayout'

export default CartItemLayout
